// extracted by mini-css-extract-plugin
module.exports = {"app":"admin-portal__AppFrame__app"};